import { CHANGELOG, PAYMENT_METHODS } from "./data";
import { CASINOS } from "./casinos";
import type { Casino, ChangelogEntry, PaymentMethod } from "./types";

/**
 * Statische datalaag: geen backend. De functies filteren de redactionele
 * constanten uit data.ts alsof het gepubliceerde records uit een CMS zijn.
 */

export function getPublishedMethods(): PaymentMethod[] {
  return [...PAYMENT_METHODS].sort((a, b) => a.sort_order - b.sort_order);
}

export function getMethodBySlug(slug: string): PaymentMethod | null {
  return PAYMENT_METHODS.find((m) => m.slug === slug) ?? null;
}

/** Publieke casino's: gepubliceerd én legaal voor Nederland. */
export function getPublicCasinos(): Casino[] {
  return CASINOS.filter((c) => c.publication_status === "published" && c.legal_for_netherlands === true).sort(
    (a, b) => (a.rank ?? 999) - (b.rank ?? 999),
  );
}

export function getCasinoBySlug(slug: string): Casino | null {
  return getPublicCasinos().find((c) => c.slug === slug) ?? null;
}

export function getChangelog(limit = 8): ChangelogEntry[] {
  return [...CHANGELOG]
    .sort((a, b) => b.published_at.localeCompare(a.published_at))
    .slice(0, limit);
}

/** Alles wat de meeste pagina's nodig hebben, in één keer. */
export function getSiteData(): { methods: PaymentMethod[]; casinos: Casino[] } {
  return { methods: getPublishedMethods(), casinos: getPublicCasinos() };
}
